import { render, staticRenderFns } from "./reporte-individual-pastel-docente.vue?vue&type=template&id=11c7ec34"
import script from "./reporte-individual-pastel-docente.vue?vue&type=script&lang=js"
export * from "./reporte-individual-pastel-docente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports